// extracted by mini-css-extract-plugin
export var buttonContent = "_3y-0";
export var centered = "_3y-1";
export var centeredFlex = "_3y-2";
export var errorText = "_3y-3";
export var icon = "_3y-4";
export var iconButtonContent = "_3y-5";
export var monospace = "_3y-6";
export var padded = "_3y-7";